export default "__VITE_ASSET__1ujyIm7w__"